import React from 'react';
import PaymentPlan from './PaymentPlan';
import './PricingSection.css';

const PricingSection = ({ config }) => {
  return (
    <div className="pricing-section">
      <div className="pricing-content">
        <h2 className="pricing-title">{config.title}</h2>
        
        <div className="pricing-cards">
          {config.units.map((unit, index) => (
            <div key={unit.id || index} className={`pricing-card ${unit.title.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="card-content">
                <div className="card-left">
                  <h3 className="unit-type">{unit.title}</h3>
                  <div className="main-price">{unit.price}</div>
                  <PaymentPlan plans={unit.paymentPlans} />
                </div>
                
                <div className="card-right">
                  {unit.backgroundImage && (
                    <div className="unit-image">
                      <img 
                        src={unit.backgroundImage} 
                        alt={`${unit.title} floor plan`}
                        className="floor-plan-image"
                      />
                    </div>
                  )}
                  
                  <div className="price-info">
                    <div className="expected-rent">
                      <span className="rent-label">Expected Rent</span>
                      <span className="rent-amount">{unit.expectedRent}</span>
                    </div>
                    <div className="plinth-area">
                      <span className="area-label">Plinth Area</span>
                      <span className="area-amount">
                        {unit.plinthArea.replace('sqft', '')}<span className="area-unit">sqft</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingSection;
